<div class="footer">
  <div>
    <h5>
      &#169; تمامی حقوق این سامانه متعلق به
      <a href="https://rialpayment.ir" target="_blank"><b>ریال پیمنت</b></a>
      می‌باشد.
    </h5>
  </div>
</div>
